import * as React from 'react';
import { Chip, Grid, PaginationItem, Pagination as PaginationMui } from '@mui/material';
import { Icon, Text } from '.';
import { align, size } from '../services/app.service';

interface Props {
  id?: string;
  page?: number;
  pageCount?: number;
  pageInfoCaption?: string;
  align?: align;
  size?: size;
  prevCaption?: string;
  nextCaption?: string;
  disablePageLabel?: boolean;
  disableButtonPage?: boolean;
  disableButtonPrev?: boolean;
  disableButtonNext?: boolean;
  onChange?: (value: number) => void;
}

export const Pagination: React.FunctionComponent<Props> = (props) => {
  const pageCount = props.pageCount || 0;
  const hidden = [props.disableButtonPage && 'page', props.disableButtonPrev && 'previous', props.disableButtonNext && 'next', ]

  return (
    <Grid container alignItems='center' justifyContent={props.align || props.disablePageLabel? 'center' : ''} mt={2}>
      {props.pageInfoCaption && pageCount>1 &&
        <Chip label= {props.pageInfoCaption + ' ' + props.page+ ' / ' + props.pageCount}/>
      }
      {pageCount>1 &&
      <PaginationMui 
        count={props.pageCount}
        page={props.page}
        color='primary'
        size={props.size}
        hidePrevButton={props.disablePageLabel}
        hideNextButton={props.disablePageLabel}
        onChange={(e, page) => props.onChange?.(page)}
        renderItem={(item) =>
          <PaginationItem
            {...item}
            page={props.disablePageLabel? '' : <Text label={item.page?.toString()} color={item.selected && 'background.default'} textAlign='center' bold />}
            component='div'
            components={{
              previous: () => <><Icon name='arrow_back'/><Text label={props.prevCaption} size={props.size} sx={{p: props.prevCaption? 1 : 0}}/></>,
              next: () => <><Text label={props.nextCaption} size={props.size} sx={{p: props.nextCaption? 1 : 0}}/><Icon name='arrow_forward'/></>,
            }}
            sx={{adding: 0, bgcolor: 'primary.light', height: props.disablePageLabel? 7 : -1}}
            hidden={hidden.includes(item.type)}
          />
        }
      />
      }
    </Grid>
  );
  
}
